import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { SSelect } from 'components/styled';

// This is to override the ui kit select
// container's css rules. Remove this when then
// ui kit updates its textfield
const SWrapper = styled.div`
  width: 100%;

  > div {
    min-height: initial;
  }
`;

interface Props {
  clusters: string[];
}

const SelectClusters = forwardRef<HTMLDivElement, Props>(
  ({ clusters }: Props, ref) => {
    const options = clusters.map(cluster => ({
      label: cluster,
      value: cluster,
    }));

    return (
      <SWrapper ref={ref}>
        <SSelect
          classNamePrefix="react-select"
          data-test="clusters-select"
          defaultValue={options[0]}
          label="Select a cluster"
          options={options}
        />
      </SWrapper>
    );
  },
);

export default SelectClusters;
